(function () {
  'use strict';

  var selectorQuery = 'quantity-selector-component, cart-quantity-selector-component';
  var buttonQuery = '.quantity-minus, .quantity-plus';

  function numberOrDefault(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function getLimits(selector, input) {
    var min = numberOrDefault(input.min, 1);
    var step = numberOrDefault(input.step, 1);
    var max = input.max === '' ? null : numberOrDefault(input.max, null);

    if (max !== null && selector.tagName.toLowerCase() === 'quantity-selector-component') {
      var cartQuantity = numberOrDefault(input.getAttribute('data-cart-quantity'), 0);
      max = Math.max(max - cartQuantity, min);
    }

    return { min: min, max: max, step: step };
  }

  function setButtonStates(selector, input, value, limits) {
    var minusButton = selector.querySelector('.quantity-minus');
    var plusButton = selector.querySelector('.quantity-plus');

    if (minusButton && !minusButton.hasAttribute('data-server-disabled')) {
      minusButton.disabled = value <= limits.min;
    }
    if (plusButton && !plusButton.hasAttribute('data-server-disabled')) {
      plusButton.disabled = limits.max !== null && value >= limits.max;
    }
  }

  function setQuantity(selector, input, value) {
    var limits = getLimits(selector, input);
    var nextValue = Math.max(limits.min, value);

    if (limits.max !== null) nextValue = Math.min(limits.max, nextValue);

    input.value = String(nextValue);
    setButtonStates(selector, input, nextValue, limits);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var button = event.target.closest(buttonQuery);
    if (!button || button.disabled) return;

    var selector = button.closest(selectorQuery);
    if (!selector || typeof selector.updateQuantity === 'function') return;

    var input = selector.querySelector('input[type="number"]');
    if (!input || input.disabled) return;

    event.preventDefault();

    var limits = getLimits(selector, input);
    var currentValue = numberOrDefault(input.value, limits.min);
    var direction = button.classList.contains('quantity-plus') ? 1 : -1;
    setQuantity(selector, input, currentValue + limits.step * direction);
  });

  document.addEventListener(
    'submit',
    function (event) {
      if (!(event.target instanceof HTMLFormElement)) return;

      var selectors = event.target.querySelectorAll(selectorQuery);
      for (var index = 0; index < selectors.length; index += 1) {
        var selector = selectors[index];
        if (typeof selector.updateQuantity === 'function') continue;

        var input = selector.querySelector('input[type="number"]');
        if (!input || input.disabled) continue;

        var limits = getLimits(selector, input);
        var currentValue = numberOrDefault(input.value, limits.min);
        setQuantity(selector, input, currentValue);
      }
    },
    true
  );
})();
